import http from "../../http-common";

class EventRightSideNewsService {
    getEventRightSideNewsService(eventPath: string) {
        return http.get(`/right-side-section/events/${eventPath}`);
    }
}

export default new EventRightSideNewsService();
